import makeStyles from "@mui/styles/makeStyles";

export default makeStyles(
  (theme) => ({
    root: {
      height: "100%",
      display: "inline-flex",
      alignItems: "flex-end",
      justifyContent: "center",
      [theme.breakpoints.up("tablet")]: {
        justifyContent: "flex-start",
        alignItems: "center",
      },
      "&:hover > a:not(:hover)": {
        opacity: 0.65,
      },
    },
    link: {
      padding: [5, 16, 25],
      color: theme.palette.primary.main,
      opacity: 0.65,
      fontSize: theme.typography.pxToRem(14),
      position: "relative",
      willChange: "opacity",
      transform: "opacity 0.1s cubic-bezier(0.25, 1, 0.5, 1)",
      "&:first-child": {
        paddingLeft: 0,
      },
      "&:last-child": {
        paddingRight: 0,
      },
      [theme.breakpoints.up("tablet")]: {
        padding: 0,
        fontSize: theme.typography.pxToRem(22),
        marginRight: 50,
        "&:last-child": {
          marginRight: 0,
        },
      },
      "&:hover": {
        opacity: 1,
      },
    },
    activelink: {
      opacity: 1,
    },
    signUpLink: {
      height: 24,
      color: theme.palette.primary.light,
      border: [1, "solid", theme.palette.secondary.main],
      display: "block",
      padding: [0, 12],
      marginBottom: 23,
      borderRadius: 12,
      willChange: "backgroundColor",
      transform: "opacity 0.1s cubic-bezier(0.25, 1, 0.5, 1)",
      "&:hover": {
        backgroundColor: theme.palette.secondary.main,
      },
    },
    signUpLinkActive: {
      backgroundColor: theme.palette.secondary.main,
    },
    linkActive: {
      opacity: 1,
      "&::after": {
        content: "''",
        display: "block",
        position: "absolute",
        bottom: 16,
        left: 18,
        right: 18,
        height: 2,
        backgroundColor: theme.palette.lightAqua,
        [theme.breakpoints.up("tablet")]: {
          left: 0,
          right: 0,
          bottom: -13,
        },
      },
      "&:first-child": {
        "&::after": {
          left: 0,
        },
      },
      "&:last-child": {
        "&::after": {
          right: 0,
        },
      },
    },
  }),
  { name: "Navigation" },
);
